<script>
import Vue from 'vue'
import { diseaseDetail } from 'api/index'
// import { debounce } from 'common/js/common'
import { getScreenSize } from 'common/js/dom'
import { COMPS_SLIDING_PERCENTAGE } from 'base/config'
import Scroll from 'base/scroll/scroll'
import ExhibitBox from 'components/views/exhibitBox'
import { Input, Icon, DefaultPage } from 'bxs-ui-vue'
Vue.use(Input)
  .use(Icon)
  .use(DefaultPage)
const NAV_SHOW_LEN = 3
const PANE_PADDING = 20

export default {
  name: 'DiseaseType',
  components: {
    Scroll,
    ExhibitBox
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    porpHeight: {
      type: Number
    },
    products: {
      type: Array,
      default: function () {
        return []
      }
    },
    activePath: {
      type: Array
    },
    isForPresentation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const { products } = this

    return {
      productList: products.slice(),
      productValue: 0,
      titleValue: 0,
      productName: [],
      title: [],
      content: [],
      diseaseItem: '',
      secondCategoryList: [],
      searchValue: [],
      cancelVisible: false,
      filterList: []
    }
  },
  computed: {
    vbHeight () {
      return this.visibleHeight - this.porpHeight
    },
    filterListEmpty () {
      const { filterList } = this
      let bEmpty = true
      if (!Array.isArray(filterList) || !filterList.length) return bEmpty
      filterList.forEach((category, index) => {
        if (category.diseaseList.length) bEmpty = false
      })
      return bEmpty
    }
  },
  watch: {
    activePath: {
      handler (active) {
        let { products } = this

        active = active.filter(item => {
          return item
        })

        let productName = []
        let title = []
        let content = []

        active.forEach((list, index) => {
          list.forEach(item => {
            const { pidx, idx, lidx } = item
            const insItem = products[pidx].insuranceLiabilities[idx]
            if (!insItem) return

            const disItem = insItem.liabilities[lidx].disease
            productName[index] = insItem.insuranceName
            if (disItem) {
              if (Array.isArray(title[index])) {
                title[index].push(disItem.title)
                content[index].push({
                  categoryId: disItem.diseaseCategoryId,
                  detail: disItem.detail
                })
              } else {
                title[index] = [disItem.title]
                content[index] = [
                  {
                    categoryId: disItem.diseaseCategoryId,
                    detail: disItem.detail
                  }
                ]
              }
            }
          })
        })

        this.productName = productName
        this.searchValue = Array.from({ length: productName.length }, v => '')
        this.title = title
        this.content = content
        this.productValue = 0
        this.titleValue = 0
        this.fetchItem()
      }
      // immediate: true
    },
    searchValue (key) {
      // this.debouncedFilterList()
      this.filterCategoryList()
    },
    secondCategoryList (value) {
      // this.debouncedFilterList()
      this.filterCategoryList()
    }
  },
  created () {
    const { width, height } = getScreenSize()
    this.visibleHeight = height * COMPS_SLIDING_PERCENTAGE
    this.navItemWidth = width / NAV_SHOW_LEN
    this._cacheDetail = {} // 缓存
    // this.debouncedFilterList = debounce(this.filterCategoryList, 500)
  },
  mounted () {},
  methods: {
    fetchItem () {
      const { productValue, titleValue, content, _cacheDetail } = this
      if (!content[productValue]) return

      const item = content[productValue][titleValue]
      if (item.categoryId) {
        const _categoryId = item.categoryId
        if (_cacheDetail[_categoryId]) {
          this.secondCategoryList = _cacheDetail[_categoryId]
        } else {
          diseaseDetail(null, _categoryId)
            .then(({ data: { data, success } } = { data: {} }) => {
              if (success && data) {
                this.secondCategoryList = data.secondCategoryList
                this._cacheDetail[_categoryId] = data.secondCategoryList
              } else {
                this.secondCategoryList = []
                this.diseaseItem = item.detail
              }
            })
            .catch(res => {
              this.secondCategoryList = []
              this.diseaseItem = item.detail
            })
        }
      } else {
        this.secondCategoryList = []
        this.diseaseItem = item.detail
      }
    },
    syncChangeProduct (index) {
      const { titleValue, content } = this

      // 一级已选序号 >= 当前产品一级分类，重置
      if (titleValue >= content[index].length) {
        this.titleValue = 0
      }
      this.productValue = index
      this.fetchItem()
      this.$emit('change-product')
    },
    handleChangeProduct (index) {
      this.syncChangeProduct(index)
      this.syncDelta &&
        this.syncDelta({ pbData: { diseaseCurrentTitle: index } })
    },
    syncChangeCategory (index) {
      this.titleValue = index
      this.fetchItem()
    },
    handleChangeCategory (index) {
      this.syncChangeCategory(index)
      this.syncDelta &&
        this.syncDelta({ pbData: { diseaseCurrentTitle: index } })
    },
    scroll (pos, maxScrollY) {
      this.syncDelta &&
        this.syncDelta({
          pbData: { diseaseScrollTop: pos.y, diseaseMaxScrollY: maxScrollY }
        })
    },
    handleScrollToEnd (end) {
      if (!end) return
      setTimeout(() => {
        const maxScrollY = this.$refs.list.scroll.maxScrollY
        this.$refs.list.scrollTo(0, maxScrollY, 400)
      }, 100)
    },
    handleFocus () {
      this.cancelVisible = true
      window.WeiyiStatSDK.submit('bzss')
    },
    handleBlur () {
      this.cancelVisible = false
    },
    handleToggle (arg, categoryIndex, index) {
      this.syncDelta &&
        this.syncDelta({
          pbData: {
            diseaseDetailShow: {
              categoryIndex,
              index,
              isShow: arg[0]
            }
          }
        })
    },
    normalizeContent (disease) {
      if (!disease) return ''
      disease = `${disease.replace(
        /\d+[\、|\.]/g,
        '</p><p><span>$&</span>'
      )}</p>`
      disease = disease.replace(/<\/p>/, '')
      return disease
    },
    filterCategoryList () {
      const { secondCategoryList, searchValue, productValue } = this
      const key = searchValue[productValue]
      if (!key) {
        this.filterList = secondCategoryList
        setTimeout(() => {
          this.$refs.list.scrollTo(0, 0, 300)
        }, 300)
        return
      }
      const categoryList = JSON.parse(JSON.stringify(secondCategoryList))
      categoryList.forEach((category, index) => {
        const diseaseList = category.diseaseList
        if (Array.isArray(diseaseList)) {
          categoryList[index].diseaseList = diseaseList.filter(item => {
            return item.name.indexOf(key) > -1
          })
        }
      })
      this.filterList = categoryList
      setTimeout(() => {
        this.$refs.list.scrollTo(0, 0, 300)
      }, 300)
    }
  }
}
</script>

<template>
  <div class="disease-type" @touchmove.prevent>
    <!-- <div class="hd">病种详情</div> -->
    <div
      class="navigation"
      :class="{ 'after-bd-b': productName.length <= 3 }"
      @touchmove.stop
    >
      <nav class="nav">
        <a
          v-for="(item, index) in productName"
          v-if="item"
          :key="index"
          href="javascript:;"
          class="item after-bd-b needsclick"
          :class="{ cur: productValue == index }"
          @click="handleChangeProduct(index)"
        >{{ item }}</a>
      </nav>
    </div>
    <div class="nav-list">
      <div
        v-for="(item, index) in title[productValue]"
        :key="index"
        class="item after-bdr"
        :class="{ cur: titleValue === index }"
        @click="handleChangeCategory(index)"
      >
        {{ item }}
      </div>
    </div>
    <div v-if="!isForPresentation" class="nav-filter">
      <template v-if="secondCategoryList.length">
        <form action="javascript:;">
          <bxs-input
            v-model.trim="searchValue[productValue]"
            type="search"
            placeholder="请输入病种名称"
            @focus="handleFocus"
            @blur="handleBlur"
          />
        </form>
        <bxs-icon name="search" />
        <button v-if="cancelVisible" slot="button" class="filter-button">
          取消
        </button>
      </template>
    </div>
    <div
      class="disease-pane-wrap"
      :class="{ 'no-category': !secondCategoryList.length }"
      :style="{ height: `${vbHeight}px` }"
    >
      <scroll
        ref="list"
        class="disease-pane"
        :listen-scroll="true"
        :pullup="true"
        :probe-type="2"
        :data="secondCategoryList.length ? filterList : { str: diseaseItem }"
        @scroll="scroll"
      >
        <div>
          <template v-if="secondCategoryList.length">
            <dl
              v-for="(category, index) in filterList"
              :key="index"
              class="dis-category"
            >
              <template v-if="category.diseaseList.length">
                <dt v-if="category.name">
                  {{ category.name }}
                </dt>
                <dd
                  v-for="(item, idx) in category.diseaseList"
                  :key="idx"
                  @click="
                    handleScrollToEnd(
                      index === filterList.length - 1 &&
                        idx === category.diseaseList.length - 1
                    )
                  "
                >
                  <exhibit-box
                    class="after-bd-b"
                    :ins-text="[]"
                    :since-self="true"
                    @toggle="handleToggle(arguments, index, idx)"
                  >
                    <template slot="title">
                      {{
                        item.number + '.' + item.name
                      }}
                    </template>
                    <template v-if="item.description">
                      <div class="des">
                        <h6>描述：</h6>
                        <p>{{ item.description }}</p>
                      </div>
                      <div v-if="item.remarks" class="remarks">
                        <h6>备注：</h6>
                        <p>{{ item.remarks }}</p>
                      </div>
                    </template>
                  </exhibit-box>
                </dd>
              </template>
            </dl>
            <bxs-default-page
              v-if="filterListEmpty"
              type="search"
            />
          </template>
          <template v-else>
            <div v-html="normalizeContent(diseaseItem)" />
          </template>
        </div>
      </scroll>
    </div>
  </div>
</template>

<style lang="postcss">
@import 'variable.css';

.disease-type {
  color: #333;
  background-color: #fff;
  > .hd {
    padding-top: 15px;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
  }
  .disease-pane-wrap {
    overflow: hidden;
    height: 100%;
    line-height: 22px;
    color: #999;

    .disease-pane {
      height: 100%;
    }
    &.no-category {
      padding: 20px;
      p {
        position: relative;
        padding-left: 30px;
        > span {
          z-index: 1;
          width: 28px;
          text-align: right;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
  .navigation {
    .nav {
      .item {
        width: auto;
        padding: 0 5px;
      }
    }
  }
  .nav-list {
    padding: 15px 15px 6px;
    font-size: 12px;
    margin-left: -9px;
    .item {
      display: inline-block;
      padding: 5px 6px;
      margin-bottom: 9px;
      margin-left: 9px;
      line-height: 1.4;
      font-size: 13px;
      border-radius: 4px;
      &:after {
        border-radius: 8px;
      }
    }
  }
  .nav-filter {
    position: relative;
    display: flex;
    > form {
      flex: 1;
    }
    .bx-input {
      padding: 0 15px 5px 15px;
    }
    .bx-input-value {
      background-color: #f2f2f2;
      border-radius: 15px;
      padding: 0 10px 0 0;
      .bx-input-body {
        padding: 0;
      }
    }
    .bx-input-control {
      padding-left: 35px !important;
      height: 30px;
      color: #333;
      &::-webkit-search-cancel-button {
        display: none;
      }
    }
    .bx-icon-search {
      position: absolute;
      left: 24px;
      top: 4px;
      color: #999;
      pointer-events: none;
    }
  }
  .filter-button {
    width: 50px;
    padding-right: 15px;
    padding-bottom: 5px;
    border: none;
    color: #666;
    font-size: 15px;
    outline: none;
    background: none;
  }
}

.dis-category {
  position: relative;
  dt {
    padding: 9px 15px;
    color: #000;
    font-size: 14px;
    background-color: #f8f8f8;
    @apply --text-ellipsis;
  }
  .exhibit-box {
    line-height: 1.2;
    &:after {
      left: 15px;
    }
    > .hd {
      .title {
        font-size: 15px;
        color: #666;
        @apply --text-ellipsis;
      }
      a {
        text-align: right;
        font-size: 18px;
      }
    }
  }
  .des,
  .remarks {
    padding: 0 15px 15px 15px;
    font-size: 14px;
    h6 {
      margin-bottom: 6px;
    }
    p {
      white-space: pre-line;
      text-align: justify;
    }
  }
}
</style>